module.exports = __webpack_public_path__ + "img/maxim.14762d3e.png";